module.exports = __webpack_public_path__ + "src/assets/img/truck3.ef1bee87.png";